import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bb4c761"
import script from "./cusDirectTaxDetails.js?vue&type=script&lang=js&external"
export * from "./cusDirectTaxDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports